import React from 'react'
import { useLocation } from 'react-router-dom'
import { ErrorPageState } from '@typesApp/AppError'
import { InteractionContext } from '@context/interaction-context/interactionContext'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/foundation/drawer/Drawer'
import { ErrorContent } from '@features/error/components/ErrorContent'
import { ErrorFooter } from '@features/error/components/ErrorFooter'
import { ErrorHeader } from '@features/error/components/ErrorHeader'

export const Error: React.FC = () => {
  const location = useLocation()

  const state: ErrorPageState = location.state
  const { errorType, title, message, ctaLabel } = state ?? {}

  return (
    <InteractionContext.Provider value={{ name: 'insurance-panel', type: 'technical-error' }}>
      <DrawerContentHeader>
        <ErrorHeader title={title} />
      </DrawerContentHeader>
      <DrawerContentBody>
        <ErrorContent message={message} errorType={errorType} ctaLabel={ctaLabel} />
      </DrawerContentBody>
      <DrawerContentFooter>
        <ErrorFooter />
      </DrawerContentFooter>
    </InteractionContext.Provider>
  )
}
